// Cấu hình dayjs dùng chung cho toàn app.
// Mục đích: cố định mọi tính toán "ngày/giờ hiện tại" về múi giờ Việt Nam (Asia/Ho_Chi_Minh),
// tránh tình trạng máy người dùng cài lệch múi giờ làm ngày bị "nhảy" sang hôm sau/hôm trước.
//
// Lưu ý quan trọng: dayjs.tz.setDefault() CHỈ ảnh hưởng các lời gọi dayjs.tz(...).
// dayjs() thường vẫn lấy theo giờ máy. Vì vậy ở các chỗ cần giờ VN phải gọi tường minh dayjs().tz().
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Ho_Chi_Minh');

export const VN_TIMEZONE = 'Asia/Ho_Chi_Minh';

export default dayjs;
